import { Alert, Card, Stack } from "@mui/material"
import { DataGrid, GridColDef } from "@mui/x-data-grid"
import { ReportPageHeader } from "../components/ReportPageHeader"
import { organizationReportPage } from "../constants/reportPages"
import { useGetOrganizationQuery } from "../services/api"
import { useAppSelector } from "../store/hooks"
import { selectActiveOrgId } from "../store/sessionSlice"
import { formatDate, formatNullable } from "./reportFormatters"

type OrganizationInfoRow = {
  id: string
  field: string
  value: string
}

const columns: GridColDef<OrganizationInfoRow>[] = [
  {
    field: "field",
    headerName: "Field",
    width: 240,
    sortable: false,
  },
  {
    field: "value",
    headerName: "Value",
    flex: 1,
    minWidth: 260,
    sortable: false,
  },
]

function OrganizationReportPage() {
  const activeOrgId = useAppSelector(selectActiveOrgId)
  const { data, error, isLoading } = useGetOrganizationQuery({
    org_id: activeOrgId,
  })

  const rows: OrganizationInfoRow[] = [
    {
      id: "name",
      field: "Name",
      value: formatNullable(data?.name),
    },
    {
      id: "status",
      field: "Status",
      value: formatNullable(data?.status),
    },
    {
      id: "max_org_members",
      field: "Max Org Members",
      value: formatNullable(data?.max_org_members),
    },
    {
      id: "num_members",
      field: "Number of Members",
      value: formatNullable(data?.num_members),
    },
    {
      id: "enabled_features",
      field: "Enabled Features",
      value:
        data?.enabled_features && data.enabled_features.length > 0
          ? data.enabled_features.join(", ")
          : "-",
    },
    {
      id: "renewal_period_begin",
      field: "Renewal Period Begin",
      value: formatDate(data?.renewal_period_begin),
    },
    {
      id: "renewal_period_end",
      field: "Renewal Period End",
      value: formatDate(data?.renewal_period_end),
    },
    {
      id: "join_code",
      field: "Join Code",
      value: formatNullable(data?.join_code),
    },
  ]

  return (
    <Stack spacing={4}>
      <ReportPageHeader
        title={organizationReportPage.pageTitle}
        description={organizationReportPage.endpointDescription}
      />

      {error && (
        <Alert severity="error">
          Error loading organization information. Please try again.
        </Alert>
      )}

      <Card>
        <DataGrid
          rows={rows}
          columns={columns}
          loading={isLoading}
          hideFooter
          disableColumnFilter
          disableColumnMenu
          disableRowSelectionOnClick
          autoHeight
        />
      </Card>
    </Stack>
  )
}

export default OrganizationReportPage
